<template>
  <router-link
    v-if="isLink"
    :to="message.url"
  >
    {{ message.text }}
  </router-link>
  <div v-else-if="hasBreaks">
    <v-row v-for="(m, index) in message.split('<br/>')" :key="index" class="mx-0 my-1">
      {{ m }}
    </v-row>
  </div>
  <span v-else>{{ message }}</span>
</template>

<script>
import _isPlainObject from 'lodash/isPlainObject';
import _has from 'lodash/has';

export default {
  props: {
    message: {
      validator: val => val !== undefined,
      required: true,
    },
  },

  computed: {
    isLink() {
      return _isPlainObject(this.message) &&
        _has(this.message, 'url') &&
        _has(this.message, 'text');
    },

    hasBreaks() {
      return typeof this.message === 'string' && this.message.includes('<br/>');
    },
  },
};
</script>
